import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { PACKAGES } from "../lib/content";

export default function PackagesPage() {
  return (
    <div data-testid="packages-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-28 md:pt-40 pb-12">
        <div className="eyebrow text-[var(--crest-gold)]">— Packages</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight mt-6 leading-[1.02] max-w-4xl">
          Customized per principal. Built for prestige.
        </h1>
        <p className="text-lg text-[var(--crest-muted)] mt-6 max-w-2xl">
          A starting framework — every engagement is tailored after an initial consultation.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24">
        <div className="grid md:grid-cols-3 gap-px bg-black/10 border border-black/10">
          {PACKAGES.map((p, i) => (
            <div
              key={p.name}
              className={`p-10 bg-white relative ${p.featured ? "bg-[var(--crest-black)] text-[var(--crest-cream)] on-dark" : ""}`}
              data-testid={`package-${i}`}
            >
              {p.featured && (
                <div className="absolute top-4 right-4 text-[10px] tracking-[0.3em] uppercase px-3 py-1" style={{ background: "var(--crest-gold)", color: "var(--crest-black)" }}>
                  Most Engaged
                </div>
              )}
              <div className="eyebrow" style={{ color: "var(--crest-gold)" }}>0{i + 1}</div>
              <h3 className="font-serif text-3xl tracking-tight mt-3">{p.name}</h3>
              <div className="mt-6 font-serif text-2xl">{p.price}</div>
              <div className="text-[11px] tracking-[0.25em] uppercase opacity-70 mt-1">{p.cadence}</div>
              <p className="text-sm mt-6 leading-relaxed opacity-80">{p.description}</p>
              <div className="hairline my-8 opacity-30" />
              <ul className="space-y-3 text-sm">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <Check size={16} style={{ color: "var(--crest-gold)" }} className="mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/book"
                className={p.featured ? "btn-secondary mt-10 w-full" : "btn-primary mt-10 w-full"}
                data-testid={`package-cta-${i}`}
              >
                Book Consultation
              </Link>
            </div>
          ))}
        </div>
        <p className="text-sm text-[var(--crest-muted)] mt-10 text-center max-w-xl mx-auto">
          Need something bespoke? <Link to="/contact" className="underline gold">Send us an inquiry</Link> with your goals, timeline, and budget.
        </p>
      </section>
    </div>
  );
}
